import { useMemo } from "react";

import {
    type GoogleProtobufTimestampInput,
    type MetricField,
    MyLensesAssetType,
    type OrganicStatsField,
    type ReportingGranularity,
    type UserDimension,
} from "../../gql-generated/types";

import { useLensBreakdownAssetQueryParams } from "./useLensBreakdownAssetQueryParams";
import { useReportingGranularity } from "./useReportingGranularity";

export interface DimensionBreakdownParams {
    lensId: string | null;
    assetType: MyLensesAssetType | null;
    breakdownAssetType: MyLensesAssetType | null;
    startTime: GoogleProtobufTimestampInput | null;
    endTime: GoogleProtobufTimestampInput | null;
    selectedGranularity: ReportingGranularity;
    fields: { fieldName: MetricField; reportDimension: UserDimension }[];
}

export const useDimensionBreakdownQueryParams = (fields: OrganicStatsField[]): DimensionBreakdownParams => {
    const { breakdownAssetType, lensId } = useLensBreakdownAssetQueryParams();
    const { startTime, endTime, selectedGranularity } = useReportingGranularity();

    return useMemo(
        () => ({
            assetType: MyLensesAssetType.User,
            breakdownAssetType,
            lensId,
            startTime,
            endTime,
            selectedGranularity,
            fields,
        }),
        [fields, breakdownAssetType, lensId, startTime, endTime, selectedGranularity],
    );
};
